(function ($, window) {
    'use strict';


    // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
    // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

    // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

    // MIT license

    (function () {
        var lastTime = 0;
        var vendors = ['ms', 'moz', 'webkit', 'o'];
        for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
            window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
            window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
                || window[vendors[x] + 'CancelRequestAnimationFrame'];
        }

        if (!window.requestAnimationFrame)
            window.requestAnimationFrame = function (callback, element) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                var id = window.setTimeout(function () { callback(currTime + timeToCall); },
                    timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };

        if (!window.cancelAnimationFrame)
            window.cancelAnimationFrame = function (id) {
                clearTimeout(id);
            };
    }());

    //On DOM Ready
    $(function () {
        var $homeHero = $('.section__hero'),

            //Element - Firm Logo 
            $logoHero = $homeHero.find('.logo-hero'),
            //Element - Primary Heading
            $titleHero = $homeHero.find('.hero__main--title'),
            //Element - Secondary Heading
            $subtitleHero = $homeHero.find('.hero__main--subtitle'),
            //Element - UI Arrow
            $arrowHero = $homeHero.find('.hero__main--arrow');


        var animateLogo = setTimeout(function () {
            $logoHero.addClass('is-animating');
        }, 500);

        var animateTitle = setTimeout(function () {
            $titleHero.addClass('is-animating');
        }, 1500);

        var animateSubtitle = setTimeout(function () {
            $subtitleHero.addClass('is-animating');
        }, 1700);

        var animateArrow = setTimeout(function () {
            $arrowHero.addClass('is-animating');
        }, 2000);


        var $headerSticky = $('.global-site-nav'),
            $body = $('body'),
            $homeLocations = $('.home-locations'),
            $prevLocationSection = $('.home-locations').prev(),
            $globalFooter = $('.global-footer'),
            //window specific variables
            bodyHeight,
            globalFooterHeight,
            homeLocationsHeight,
            pageOffset,
            homeHeroHeightOffset,
            mobileState = false,
            rAFTicker = false,
            windowWidth;

        function checkOffsets() {
            homeHeroHeightOffset = $homeHero.outerHeight();

            windowWidth = window.innerWidth;

            (windowWidth < 768) ? mobileState = true : mobileState = false;
        }

        checkOffsets();

        $arrowHero.on('click.arrowScroll', function (ev) {
            ev.preventDefault();
            $('html,body').animate({
                scrollTop: homeHeroHeightOffset
            }, 800);
        });


        function calculateBodyHeight() {
            globalFooterHeight = $globalFooter.outerHeight();
            homeLocationsHeight = $homeLocations.outerHeight();
            bodyHeight = $body.height() / 2;

            $homeLocations.css('bottom', globalFooterHeight);
            $prevLocationSection.css('margin-bottom', globalFooterHeight + homeLocationsHeight);
        }

        function requestTicker() {
            if (!rAFTicker) {
                requestAnimationFrame(function () {
                    desktopHeaderLogic();
                    revealingFooterLogic();
                });
            }

            rAFTicker = true;
        }

        function desktopHeaderLogic() {

            rAFTicker = false;

            pageOffset = window.pageYOffset;

            if (pageOffset >= homeHeroHeightOffset) {
                //Animate Header  and stick to the top of the page
                $headerSticky.addClass('is-fixed is-animating');


            }

            else {
                //hide Logo and unStickheader
                $headerSticky.removeClass('is-fixed is-animating');


            }
        }

        function revealingFooterLogic() {

            pageOffset = window.pageYOffset;

            //If we are homero, attached offset
            if (pageOffset > bodyHeight) {

                //hide Hero
                $homeHero.addClass('is-disabled');

                //add fixed class after scrolling down to naturally calculate the height of the footer and locations section
                $homeLocations.addClass('is-activated');
                $globalFooter.addClass('is-activated');
            }

            else {

                //reshow hero
                $homeHero.removeClass('is-disabled');

                $homeLocations.removeClass('is-activated');
                $globalFooter.removeClass('is-activated');
            }

        }

        function homepageInit() {

            if (mobileState === false) {

                calculateBodyHeight();

                desktopHeaderLogic();

                revealingFooterLogic();

                $(window).on('scroll.homepage', function () {
                    requestTicker();
                });
            }

            else {
                $(window).off('scroll.homepage');
            }

        }

        homepageInit();


        var resizeTimer;

        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(
                function () {
                    checkOffsets();
                    homepageInit();
                }, 300);
        });

    });


})(jQuery, window);